import React from "react";
import PropTypes from "prop-types";
import Img from "gatsby-image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.scss";

const settings = {
  infinite: true,
  arrows: true,
  dots: false,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true
};

const Carousel = ({ images }) => {
  return (
    <Slider {...settings}>
      {images.map((image, index) => (
        <Img key={index} fluid={image.fluid} />
      ))}
    </Slider>
  );
};

Carousel.propTypes = {
  images: PropTypes.array.isRequired
};

export default Carousel;
